import React from "react";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { Post } from "../../config/api/post";
import { AUTH } from "../../config/constants";
import { AuthPage, LoginForm } from "../../components/login-form";

function ForgetPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const onSubmit = (values) => {
    setLoading(true);

    Post(AUTH.emailCode, values)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          toast.success(response?.data?.message || "Verification code sent");
          navigate("/forgot-password-2", { replace: true, state: values });
        } else {
          toast.error(response?.data?.message || "Request failed");
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.data?.message || e?.message || "Internal server error");
      });
  };

  return (
    <AuthPage>
      <LoginForm
        title="Forgot password"
        description="We'll send a verification code to your email"
        submitLabel="Send code"
        loading={loading}
        onSubmit={onSubmit}
        fields={[
          {
            name: "email",
            label: "Email",
            type: "email",
            placeholder: "admin@thebirchwoodacademy.com",
            autoComplete: "email",
          },
        ]}
        footer={
          <button
            type="button"
            className="text-center text-sm font-medium underline-offset-2 hover:underline"
            onClick={() => navigate("/signin")}
          >
            Back to login
          </button>
        }
      />
    </AuthPage>
  );
}

export default ForgetPassword;
